export default "__VITE_ASSET__ClYoY0S7__"